import { TKey } from "@/app/translations/TKey";

export const FLOW_INPUTS: TKey[] = [
  TKey.HOME_MEIDLY_FLOW_IN_1,
  TKey.HOME_MEIDLY_FLOW_IN_2,
  TKey.HOME_MEIDLY_FLOW_IN_3,
];

export const FLOW_OUTPUTS: TKey[] = [
  TKey.HOME_MEIDLY_FLOW_OUT_1,
  TKey.HOME_MEIDLY_FLOW_OUT_2,
  TKey.HOME_MEIDLY_FLOW_OUT_3,
  TKey.HOME_MEIDLY_FLOW_OUT_4,
];
